import React from 'react';
import SMConst from 'lib/SMConst';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMOSpaceCoverPhotoView extends SMFormFieldBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      display: SMConst.Display.Visible,
    };
  }
  
  componentDidMount() {
    $(document).on("SMSpaceDidUpdateSuccess", this.spaceDidUpdateSuccess.bind(this));
    $(document).on("SMSpaceDidFailToUpdate", this.spaceDidFailToUpdate.bind(this));
    $(document).on("SMSpaceDidStartToUpdate", this.spaceDidStartToUpdate.bind(this));
  }
  
  componentWillUnmount(){
    $(document).off("SMSpaceDidUpdateSuccess", this.spaceDidUpdateSuccess);
    $(document).off("SMSpaceDidFailToUpdate", this.spaceDidFailToUpdate);
    $(document).off("SMSpaceDidStartToUpdate", this.spaceDidStartToUpdate);
  }
  
  spaceDidStartToUpdate(e, name, value){
    this.setState({display: SMConst.Display.Loading});
    if (name == this.props.name) {
      $(this.refs.coverpic).startLoading({
        color: "#ffffff"
      });
    }
  }
  
  spaceDidUpdateSuccess(e, name, value){
    this.setState({display: SMConst.Display.Visible});
    if (name == this.props.name) {
      $(this.refs.coverpic).stopLoading();
    }
  }
  
  spaceDidFailToUpdate(e, name, value, errors){
    this.setState({display: SMConst.Display.Visible});
    $(this.refs.coverpic).stopLoading();
  }
  
  onChange(e) {
    if(this.props.delegate && typeof this.props.delegate.fileFieldDidChangeValue === 'function'){
      this.props.delegate.fileFieldDidChangeValue(e);
    }
  }
  
  onClick(e) {
    e.preventDefault();
    if (this.state.display == SMConst.Display.Loading) return;
    this.refs.inputFile.click();
  }
  
  render() {
    const imageURL = SMFormatHelper.spaceImageURL(this.props.space, {width: 1200, height: 670});
    const coverStyle = { backgroundImage: "url('"+ imageURL +"')" };
    
    return (
      <div>
        <div ref="coverpic"  className="form-coverpic" style={coverStyle}>
          <input type="file" name={this.props.name} ref='inputFile' onChange={this.onChange.bind(this)} hidden />
          <p>
            <a onClick={this.onClick.bind(this)} href="#" className="form-coverpic__link">
              <i className="fa fa-camera"></i> {imageURL == '' ? I18n.t('dashboard.label_000126') : I18n.t('dashboard.label_000127')}
            </a>
          </p>
        </div>


        <h2 className="dashboard-title mb20">
          <span className="icon-form icon-form__required">必須</span>カバー写真
          <span className="dashboard-title__supplement ml15">
            外観や会場全体を表す画像ををアップロードして下さい。
          </span>
        </h2>
        <div className="form-box">
          <span onClick={this.onClick.bind(this)} className="settings-img__change-img" style={coverStyle}>
             <label className="button-gray settings-img">
               <span className="icon-ll"><i className="fa fa-camera"></i></span><br />{imageURL == '' ? I18n.t('dashboard.label_000126') : I18n.t('dashboard.label_000127')}
             </label>
          </span>
        </div>
      </div>
    );
  }
}
export default SMOSpaceCoverPhotoView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/SMOSpaceCoverPhotoView.jsx